export function formatCompanyDocumentSize(
  value?: string | number | null
): string {
  const bytes = typeof value === "number" ? value : Number(value || 0);
  if (!Number.isFinite(bytes) || bytes <= 0) return "—";
  const units = ["B", "KB", "MB", "GB"];
  const unitIndex = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1
  );
  const amount = bytes / 1024 ** unitIndex;
  return `${
    amount >= 10 || unitIndex === 0 ? amount.toFixed(0) : amount.toFixed(1)
  } ${units[unitIndex]}`;
}

export function formatCompanyDocumentDate(value?: string | null): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/** Signed S3 URLs must be used unchanged: appending a cache buster invalidates
 * AWS's query signature. */
export function openCompanyDocumentDownload(url: string) {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.target = "_blank";
  anchor.rel = "noopener noreferrer";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export function createCompanyDocumentClientId() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return `document-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
